import { Avatar } from 'antd';
import { FC, useMemo } from 'react';
import UserAvatarPopover from 'components/UserAvatarPopover';
import style from './index.module.less';

interface UserAvatarsPopoverProps {
  users?: any[];
  collapse?: boolean;
  filterType?: 'responsible' | 'follower';
  maxCount?: number;
}

const UserAvatarsPopover: FC<UserAvatarsPopoverProps> = ({ users, filterType, maxCount, collapse = false }) => {
  const list = useMemo(() => {
    return filterType ? users?.filter((item) => item.pivot?.type === filterType) : users;
  }, [filterType, users]);

  return (
    <div style={{ display: 'flex' }}>
      <Avatar.Group
        className={collapse ? style.groupCollapse : ''}
        style={{ display: 'inline-flex', alignItems: 'center', flexWrap: 'nowrap' }}
        maxCount={maxCount}
      >
        {list?.map((item) => (
          <UserAvatarPopover key={item.uuid} user={item} collapsible={collapse ? style.collapsibleAvatar : ''} />
        ))}
      </Avatar.Group>
    </div>
  );
};

export default UserAvatarsPopover;
